import React from 'react';
import { Button, MarkdownHTML, Modal } from '../..';
import { paths } from '../../../routes';
import env from '../../../utils/env';

type ModalProps = {
  allSetPrice: string | null;
  onCloseModal: () => void;
};

function TransitionToPayNotice({ onCloseModal, allSetPrice }: ModalProps) {
  const notice = allSetPrice
    ? `Your payment information has been updated! Your first plan payment of ${allSetPrice} is scheduled for **May 1, 2025.**`
    : 'Beginning **May 1, 2025**, your plan payment will be self-pay. To access your account, click next to update your payment information.';

  return (
    <Modal onClose={undefined} show onHide={() => false}>
      <div className="rounded-xl bg-white tablet:w-[600px] laptop:w-[600px]">
        <div className="flex flex-col px-6 tablet:px-12 py-10 pb-12 items-center">
          {allSetPrice ? (
            <>
              <span className="w-[70px] h-[70px] bg-[#F5FAF4] rounded-full flex mb-5 items-center justify-center">
                <img
                  alt="loader status"
                  width={40}
                  height={40}
                  src="/assets/images/billing_success_min.gif"
                />
              </span>

              <h3 className="text-river-black text-[20px] font-bold inline-flex text-center items-center px-2 tablet:px-0 mobile:leading-normal">
                All Set!
              </h3>

              <div className="mt-2 flex flex-col text-base leading-[24px] mb-2">
                <MarkdownHTML
                  className="text-sm text-center text-river-black px-1"
                  content={notice}
                />
              </div>
            </>
          ) : (
            <>
              <h3 className="text-river-black text-[20px] font-bold inline-flex text-center items-center px-2 tablet:px-0 mobile:leading-normal">
                Notice!
              </h3>

              <div className="mt-3 flex flex-col text-base leading-[24px]">
                <MarkdownHTML
                  className="text-sm text-center text-river-black px-1 text-pretty"
                  content={notice}
                />
              </div>

              <hr className="w-full tablet:w-[70%] my-5 mx-auto" />
              <p className="text-center">
                Have questions? Visit our Support Center at{' '}
                <a className="text-river-deep-orange" href={paths.SUPPORT_URL_PATH}>
                  {`${env('RIVER_APP_URL')}/support`.replace(/https?:\/\//, '')}
                </a>
              </p>
            </>
          )}

          <div className="mt-8 tablet:mt-6">
            <Button label={allSetPrice ? 'Done' : 'Continue'} onClick={onCloseModal} />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default TransitionToPayNotice;
